<div class="row rounded-card" id="settings-features-management">
  <div class="flex flex-wrap justify-between items-end mb-4" id="setting-view-header-wr">
    <div class="flex flex-col">
      <h2 data-testid="features-title">{{ 'SYSTEM_SETTINGS.MODULES.FEATURES_MGMT_TITLE'| translate }}</h2>
    </div>
    <div class="flex flex-col col-12">
      <span data-testid="features-enabled-features-subtitle" class="block text-base">{{ 'SYSTEM_SETTINGS.MODULES.ENABLE_MODULES_LABEL' | translate }}
      </span>
    </div>
  </div>

  <hr class="w-full mb-1 mt-2 border-t">
  <div class="row">
    <div class="col-12 p-0">
      <accordion id="feature-list" [expandIcon]="'icon-arrow-down'" [collapseIcon]="'icon-arrow-up'" [multiple]="true">
        @for (feature of featuresListDisplay; track feature; let i = $index) {
          <accordion-tab [header]="feature.name">
            <div class="row">
              <div class="col">
                <!-- <h3>{{ feature.name | translate }}:</h3> -->
              </div>
              <div class="col-auto">
                @if (feature.name != 'Security') {
                  <div class="switch-wr">
                    <p-selectButton class="status-switch" [class.status-active]="getFeatureValue(feature)" [options]="stateOptions" optionLabel="label" optionValue="value" [allowEmpty]="false" [ngModel]="getFeatureValue(feature)" (onChange)="onStateChange($event, feature)">

                      <ng-template #item let-option>
                        <span class="status-option" [attr.data-testid]="option.value ? 'btn-feature-activate' : 'btn-feature-deactivate'">
                          <i class="pi pi-check status-check" aria-hidden="true"></i>
                          <span>{{ getFeatureStateLabel(option.value, feature) }}</span>
                        </span>
                      </ng-template>
                    </p-selectButton>
                  </div>
                }
              </div>
            </div>
              <div class="row">
                @if (feature.name == 'Inventories') {
                  <div class="field-wr col-12">
                    <div class="row">
                      <div class="col-6">
                        <label data-testid="add-company-field-inventory-threshold" class="block text-sm "
                          for="inventorySubmissionThresholdDays">{{ 'SYSTEM_SETTINGS.INVENTORY_THRESHOLD' | translate }} <i
                        class="icon-required-field"></i></label>
                        <input data-testid="add-company-inventory-threshold-input" type="number"
                          [(ngModel)]="inventorySubmissionThresholdDays" autocomplete="off" min="0">
                      </div>
                    </div>
                  </div>
                }
                @if (feature.name == 'Warranties') {
                  <div class="field-wr col-12">
                    <div class="row">
                      <div class="col-6">
                        <label ata-testid="add-company-field-warranty-use-limit" class="block text-sm"
                          for="warrantyUseLimit">{{
                          'SYSTEM_SETTINGS.WARRANTY_USE_LIMIT' | translate }}</label>
                        <input data-testid="add-company-warranty-use-limit-input" type="number" [(ngModel)]="warrantyUseLimit"
                          autocomplete="off" min="1">
                      </div>
                      <br>
                        <div class="field-wr col-12 col-sm-6 col-md-6 col-lg-4" [ngClass]="{'disabled': disableIsPrepaired}">
                          <label data-testid="add-company-field-prepaired-warranty" class="block text-sm mb-3"
                            for="isPrepaired">{{ 'SYSTEM_SETTINGS.COMPANY.IS_PREPAIRED' | translate
                          }}</label>
                          <label data-testid="add-company-prepaired-warranty-yes-label" class="inline-flex mr-3">
                            <p-radioButton data-testid="add-company-prepaired-warranty-yes" name="isPrepaired" value="true"
                              [(ngModel)]="isPrepaired" inputId="prepaired-yes" />
                            <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                          </label>
                          <label data-testid="add-company-prepaired-warranty-no-label" class="inline-flex mr-1">
                            <p-radioButton data-testid="add-company-prepaired-warranty-no" name="isPrepaired" value="false"
                              [(ngModel)]="isPrepaired" inputId="prepaired-no" />
                            <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                          </label>
                        </div>

                      </div>
                    </div>
                  }
                  @if (feature.name == 'DigitalPassport') {
                    <div class="field-wr col-12">
                      <div class="row">
                        <div class="col-12">
                          <label data-testid="add-company-field-digitalpassporturl" class="block text-sm" for="digitalPassportUrl">{{
                            'SYSTEM_SETTINGS.MODULES.DIGITAL_PASSPORT_DESTINATION_URL' |
                          translate }}</label>
                          <input data-testid="add-company-digitalpassporturl-input" type="text" [(ngModel)]="digitalPassportUrl"
                            autocomplete="off">
                        </div>
                      </div>
                    </div>
                    <div class="field-wr col-12">
                      <div class="flex flex-row gap-2">
                        <p-checkbox data-testid="digital-passport-security-passcode-required" [binary]="true" [(ngModel)]="isDigitalPassportSecurityPasscodeRequired" inputId="digital-passport-security-passcode-required" />
                        <label for="digital-passport-security-passcode-required">
                          {{ 'SYSTEM_SETTINGS.MODULES.REQUEST_SECURITY_CODE' | translate }}
                        </label>
                      </div>
                    </div>
                  }
                  @if (feature.name == 'Products') {
                    <div class="field-wr col-12">
                      <div class="row">
                        <div class="col-4">
                          <label data-testid="add-company-field-limited-edition" class="block text-sm mb-3"
                            for="hasLimitedEdition">
                          {{ 'SYSTEM_SETTINGS.COMPANY.HAS_LIMITED_EDITION' | translate }}</label>
                          <label data-testid="add-company-limited-edition-yes-label" class="inline-flex mr-3">
                            <p-radioButton data-testid="add-company-limited-edition-yes" name="hasLimitedEdition" value="1"
                              [(ngModel)]="hasLimitedEdition" inputId="limited-edition-yes" />
                            <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                          </label>
                          <label data-testid="add-company-limited-edition-no-label" class="inline-flex mr-1">
                            <p-radioButton data-testid="add-company-limited-edition-no" name="hasLimitedEdition" value="0"
                              [(ngModel)]="hasLimitedEdition" inputId="limited-edition-no" />
                            <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                          </label>
                        </div>
                        <div class="col-4">
                          <label data-testid="add-company-field-hasCpo" class="block text-sm mb-3"
                            for="hasCpo">
                          {{ 'SYSTEM_SETTINGS.COMPANY.HAS_CPO' | translate }}</label>
                          <label data-testid="add-company-hasCpo-yes-label" class="inline-flex mr-3">
                            <p-radioButton data-testid="add-company-hasCpo-yes" name="hasCpo" value="1"
                              [(ngModel)]="hasCpo" inputId="hasCpo-yes" />
                            <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                          </label>
                          <label data-testid="add-company-hasCpo-no-label" class="inline-flex mr-1">
                            <p-radioButton data-testid="add-company-hasCpo-no" name="hasCpo" value="0"
                              [(ngModel)]="hasCpo" inputId="hasCpo-no" />
                            <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                          </label>
                        </div>
                        <div class="col-4">
                          <label data-testid="add-company-field-hasPrice" class="block text-sm mb-3" for="hasPrice">
                          {{ 'SYSTEM_SETTINGS.COMPANY.HAS_PRICE' | translate }}</label>
                          <label data-testid="add-company-hasPrice-yes-label" class="inline-flex mr-3">
                            <p-radioButton data-testid="add-company-hasPrice-yes" name="hasPrice" value="1" [(ngModel)]="hasPrice"
                              inputId="hasPrice-yes" />
                            <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                          </label>
                          <label data-testid="add-company-hasPrice-no-label" class="inline-flex mr-1">
                            <p-radioButton data-testid="add-company-hasPrice-no" name="hasPrice" value="0" [(ngModel)]="hasPrice"
                              inputId="hasPrice-no" />
                            <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                          </label>
                        </div>
                        <div class="col-4 mt-4">
                          <label data-testid="is-serial-number-required" class="block text-sm mb-3" for="hasItemsWithoutSerialNumber">
                          {{ 'SYSTEM_SETTINGS.MODULES.HAS_ITEMS_WITHOUT_SN' | translate }}</label>
                          <label data-testid="is-sn-required-yes-label" class="inline-flex mr-3">
                            <p-radioButton data-testid="is-sn-required-yes" name="hasItemsWithoutSerialNumber" value="1" [(ngModel)]="hasItemsWithoutSerialNumber"
                              inputId="hasItemsWithoutSerialNumber-yes" />
                            <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                          </label>
                          <label data-testid="is-sn-required-no-label" class="inline-flex mr-1">
                            <p-radioButton data-testid="is-sn-required-no" name="hasItemsWithoutSerialNumber" value="0" [(ngModel)]="hasItemsWithoutSerialNumber"
                              inputId="hasItemsWithoutSerialNumber-no" />
                            <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                          </label>
                        </div>
                      </div>
                      <br>
                        <div class="row">
                          <div class="col-md-4 col-sm-4 co-md-4 col-lg-4 col-xl-4 mt-1">
                            <div class="flex flex-row gap-2">
                              <p-checkbox data-testid="display-product-attributes" binary="true" [(ngModel)]="showProductAttributeDetails" inputId="display-product-attributes" />
                              <label for="display-product-attributes">
                                {{ 'SYSTEM_SETTINGS.MODULES.PRODUCTS_SPECIAL_FIELD_SHOW_PRODUCT_ATTRIBUTES' | translate }}
                              </label>
                            </div>
                          </div>
                          <div class="col-md-4 col-sm-4 co-md-4 col-lg-4 col-xl-4 mt-1">
                            <div class="flex flex-row gap-2">
                              <p-checkbox data-testid="display-item-security-code" binary="true" [(ngModel)]="showSecurityCode" inputId="display-item-security-code" />
                              <label for="display-item-security-code">
                                {{ 'SYSTEM_SETTINGS.MODULES.ITEMS_SPECIAL_FIELD_SHOW_SECURITY_CODE' | translate }}
                              </label>
                            </div>
                          </div>
                          <div class="col-md-4 col-sm-4 co-md-4 col-lg-4 col-xl-4 mt-1">
                            <div class="flex flex-row gap-2">
                              <p-checkbox data-testid="display-item-security-code-version" binary="true" [(ngModel)]="showSecurityCodeVersion" inputId="display-item-security-code-version" />
                              <label for="display-item-security-code-version">
                                {{ 'SYSTEM_SETTINGS.MODULES.ITEMS_SPECIAL_FIELD_SHOW_SECURITY_CODE_VERSION' | translate }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    @if (feature.name == 'Repair') {
                      <div class="field-wr col-12">
                        <div class="row">
                          <div class="col-md-4 col-sm-4 co-md-4 col-lg-4 col-xl-4 mt-1">
                            <div class="flex flex-row gap-2">
                              <p-checkbox data-testid="repair-sold-items" binary="true" [(ngModel)]="repairOnlySoldItems" inputId="repair-sold-items" />
                              <label for="repair-sold-items">
                                {{ 'SYSTEM_SETTINGS.MODULES.ITEMS_SPECIAL_FIELD_REPAIR_SOLD_ITEMS_ONLY' | translate }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    @if (feature.name == 'SerialisationEngine') {
                      <div class="field-wr col-12">
                        <div class="row">
                          <div class="col-4">
                            <label data-testid="add-company-field-direct-import" class="block text-sm mb-3"
                            for="directImportEnabled"> {{ 'SYSTEM_SETTINGS.COMPANY.DIRECT_IMPORT' | translate }}</label>
                            <label data-testid="add-company-direct-import-yes-label" class="inline-flex mr-3">
                              <p-radioButton data-testid="add-company-direct-import-yes" name="directImportEnabled" value="1"
                                [(ngModel)]="directImportEnabled" inputId="direct-import-yes" />
                              <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                            </label>
                            <label data-testid="add-company-direct-import-no-label" class="inline-flex mr-1">
                              <p-radioButton data-testid="add-company-direct-import-no" name="directImportEnabled" value="0"
                                [(ngModel)]="directImportEnabled" inputId="direct-import-no" />
                              <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    }
                    @if (feature.name == 'Sales') {
                      <div class="field-wr col-12">
                        <div class="row">
                          <div class="field-wr col-12">
                            <div class="flex flex-row gap-2">
                              <p-checkbox data-testid="sale-create-serial-number" binary="true"
                                [(ngModel)]="allowSerialNumberCreationDuringSale" inputId="sale-create-serial-number" />
                              <label for="sale-create-serial-number">
                                {{ 'SYSTEM_SETTINGS.MODULES.SALE_SPECIAL_SERIAL_NUMBER_FIELD' | translate }}
                              </label>
                            </div>
                          </div>
                          <div class="field-wr col-12">
                            <div class="flex flex-row gap-2">
                              <p-checkbox data-testid="sale-is-legacy" binary="true" [(ngModel)]="isLegacy" inputId="sale-is-legacy" />
                              <label for="sale-is-legacy">
                                {{ 'SYSTEM_SETTINGS.MODULES.SALE_SPECIAL_IS_LEGACY_FIELD' | translate }}
                              </label>
                            </div>
                          </div>
                          <div class="field-wr col-12">
                            <div class="flex flex-row gap-2 ">
                              <p-checkbox data-testid="sale-allow-item-operation-other-retailer" binary="true"
                                [(ngModel)]="allowItemOperationsSoldByAnotherRetailer" inputId="sale-allow-item-operation-other-retailer" />
                              <label for="sale-allow-item-operation-other-retailer">
                                {{ 'SYSTEM_SETTINGS.MODULES.ALLOW_ITEM_OPERATION_OTHER_RETAILER' | translate }}
                              </label>
                            </div>
                          </div>
                          <div class="field-wr col-12">
                            <label data-testid="add-company-field-implicit-sale" class="block text-sm mb-3"
                            for="implicitSaleCreation">{{ 'SYSTEM_SETTINGS.COMPANY.IMPLICIT_SALE' | translate }}</label>
                            <label data-testid="add-company-implicit-sale-yes-label" class="inline-flex mr-3">
                              <p-radioButton data-testid="add-company-implicit-sale-yes" name="implicitSaleCreation" value="1"
                                [(ngModel)]="implicitSaleCreation" inputId="prepaired-yes" />
                              <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                            </label>
                            <label data-testid="add-company-implicit-sale-no-label" class="inline-flex mr-1">
                              <p-radioButton data-testid="add-company-implicit-sale-no" name="implicitSaleCreation" value="0"
                                [(ngModel)]="implicitSaleCreation" inputId="prepaired-no" />
                              <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                            </label>
                          </div>
                          @if (isUpdate) {
                            <div class="field-wr col-12">
                              <label data-testid="add-company-field-assistance-image" class="block text-sm mb-3"
                                for="setSerialNumberAssistanceImage">
                                {{ 'SYSTEM_SETTINGS.COMPANY.DISPLAY_SERIAL_IMAGE' | translate}}
                              </label>
                              <label data-testid="add-company-assistance-image-yes-label" class="inline-flex mr-3">
                                <p-radioButton data-testid="add-company-assistance-image-yes" name="setSerialNumberAssistanceImage"
                                  value="1" [(ngModel)]="setSerialNumberAssistanceImage" inputId="set-serial-assist-yes" />
                                <span for="set-serial-assist-yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                              </label>
                              <label data-testid="add-company-assistance-image-no-label" class="inline-flex mr-1">
                                <p-radioButton data-testid="add-company-assistance-image-no" name="setSerialNumberAssistanceImage"
                                  value="0" [(ngModel)]="setSerialNumberAssistanceImage" inputId="set-serial-assist-no" />
                                <span for="set-serial-assist-no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                              </label>
                            </div>
                          }
                          <div class="flex flex-col col-12 mb-2" [hidden]="setSerialNumberAssistanceImage == 0">
                            <div class="row">
                              <div class="flex flex-col col-12">
                                @if (assistanceSerialNumberImage) {
                                  <div
                                    class="assistance-image-preview-container">
                                    <div class="assistance-image-preview">
                                      @if (!imageLoadFailed) {
                                        <img [src]="assistanceSerialNumberImage" alt="Image" class="assistance-image-thumbnail"
                                          (error)="onImageLoadError()" />
                                      }
                                      @if (imageUpdated) {
                                        <div class="flex flex-col">
                                          <small class="block text-sm success">Image uploaded successfully!</small>
                                        </div>
                                      }
                                      @if (imageLoadFailed) {
                                        <div class="assistance-image-fallback flex flex-col items-center text-center gap2"
                                          >
                                          {{ 'SYSTEM_SETTINGS.THEME.IMAGE_BROKEN' | translate }}
                                          <button data-testid="upload-assistance-image-btn" type="button"
                                            class="btn text-sm mt-2 border-none" (click)="showUploadPrompt()">
                                            Upload assistance image
                                          </button>
                                        </div>
                                      }
                                      @if (!imageLoadFailed) {
                                        <button data-testid="remove-assistance-image-btn" type="button"
                                          class="btn text-sm outline-btn" (click)="onImageRemove()">
                                          {{ 'SYSTEM_SETTINGS.THEME.REMOVE_IMAGE' | translate }}
                                        </button>
                                      }
                                    </div>
                                  </div>
                                } @else {
                                  <p-fileUpload name="file" accept="image/*" maxFileSize="1000000"
                                    chooseLabel="{{ 'SYSTEM_SETTINGS.THEME.BTN_ATTACH_FILE' | translate }}"
                                    (onSelect)="handleFileSelect($event)" (onRemove)="onImageRemove()" [customUpload]="true"
                                    [showUploadButton]="false" [showCancelButton]="false">
                                    <ng-template pTemplate="empty">
                                      <div class="flex align-items-center justify-content-center flex-column">
                                        <i class="pi pi-cloud-upload border-2"></i>
                                        <p class="mt-2 mb-1">{{ 'SYSTEM_SETTINGS.THEME.ATTACH_FILES_BY_DRAG_AND_DROP' | translate }}</p>
                                      </div>
                                    </ng-template>
                                  </p-fileUpload>
                                  <div class="error-hint-wr">
                                    @if (fileUploadError) {
                                      <small data-testid="file-upload-error" class="p-error" class="p-error">
                                      {{ fileUploadError }}</small>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    @if (feature.name == 'Retailers') {
                      <div class="field-wr col-12">
                        <div class="row">
                          <div class="col-12 col-sm-6 col-md-3 mt-1 flex items-center gap-2">
                            <p-checkbox data-testid="retailer-business-group" inputId="retailer-business-group" binary="true" [(ngModel)]="businessGroup" />
                            <label for="retailer-business-group">
                              {{ 'SYSTEM_SETTINGS.MODULES.RETAILER_BUSINESS_GROUP_FIELD' | translate }}
                            </label>
                          </div>
                          <div class="col-12 col-sm-6 col-md-4 mt-1 flex items-center gap-2">
                            <p-checkbox data-testid="display-retailer-attributes" inputId="display-retailer-attributes" binary="true" [(ngModel)]="showRetailerAttributeDetails" />
                            <label for="display-retailer-attributes">
                              {{ 'SYSTEM_SETTINGS.MODULES.RETAILERS_SHOW_RETAILER_ATTRIBUTES' | translate }}
                            </label>
                          </div>
                        </div>
                      </div>
                    }
                    @if (feature.name == 'Security') {
                      <div class="field-wr col-12">
                        <div class="row">
                          <div class="col-6 mt-1 flex items-center gap-2">
                            <p-checkbox data-testid="user-allow-password-change" inputId="user-allow-password-change" binary="true" [(ngModel)]="allowPasswordChange" />
                            <label for="user-allow-password-change">
                              {{ 'SYSTEM_SETTINGS.MODULES.USER_SPECIAL_FIELD_CHANGE_PASSWORD' | translate }}
                            </label>
                          </div>
                        </div>
                      </div>
                    }
                    @if (feature.name == 'Mfa') {
                      <div class="field-wr col-12">
                        <div class="row">
                          <div class="col-md-4 col-sm-4 co-md-4 mt-1 flex items-center gap-2">
                            <p-checkbox data-testid="require-mfa" inputId="require-mfa" binary="true" [(ngModel)]="isMfaMandatory" />
                            <label for="require-mfa">
                              {{ 'SYSTEM_SETTINGS.MODULES.MFA_SPECIAL_FIELD_ENABLE_MFA' | translate }}
                            </label>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </accordion-tab>
              }
            </accordion>
          </div>
        </div>

        <div class="col-12 mt-6 mb-4 pt-8 border-t">
          <div class="flex items-center justify-end gap-3">
            <button data-testid="update-features-settings-btn" class="btn primary-btn" (click)="updateModulesSettings()">{{
            'SYSTEM_SETTINGS.MODULES.SAVE_CHANGES' | translate }}</button>
          </div>
        </div>
      </div>
